<template>
    <div>
        <view-nav title="Admissions"/>

        <div class="view-content container-fluid">
            <div class="row">
                <div class="col-2">
                    <ul class="box nav">
                        <li class="nav-item w-100">
                            <router-link to="/admissions/week" exact-path class="nav-link">
                                <icon name="calendar" class="red"></icon> Per week
                            </router-link>
                        </li>
                        <li class="nav-item w-100">
                            <router-link to="/admissions/day" exact-path class="nav-link">
                                <icon name="calendar"></icon> Per day
                            </router-link>
                        </li>
                        <li class="nav-item w-100">
                            <router-link to="/admissions/year" class="nav-link">
                                <icon name="calendar"></icon> Per year
                            </router-link>
                        </li>
                        <li class="nav-item w-100">
                            <router-link to="/admissions/cinema" class="nav-link">
                                <icon name="home"></icon> Per cinema
                            </router-link>
                        </li>
                        <li class="nav-item w-100">
                            <router-link to="/admissions/movie" class="nav-link">
                                <icon name="film"></icon> Per movie
                            </router-link>
                        </li>
                        <li class="nav-item w-100">
                            <router-link to="/admissions/movie-tag" class="nav-link">
                                <icon name="tag"></icon> Per movie tag
                            </router-link>
                        </li>
                        <li class="nav-item w-100">
                            <router-link to="/admissions/sources" class="nav-link">
                                <icon name="file-text"></icon> Source files
                            </router-link>
                        </li>
                        <li class="nav-item w-100">
                            <router-link to="/admissions/sync" class="nav-link">
                                <icon name="download"></icon> FTP sync
                            </router-link>
                        </li>
                    </ul>
                    <div class="box">
                        <div class="box-content">
                            <heading upper="Help" border>
                                <template v-slot:lower>
                                    Browse imported admissions. Click a row to see per-cinema totals,
                                    then click a cinema to see per-title totals.
                                    <em>Per cinema</em> shows Brightfish admissions per site over the
                                    last 52 weeks, per cinema year and with the top movies per year.
                                    <em>Per movie tag</em> splits the Brightfish admissions of each cinema
                                    year per Movix target-pack tag, with the top 10 movies per tag.
                                    <em>Per movie</em> ranks the movies per cinema year and shows, per movie,
                                    its active weeks and the Cinedata titles mapped to it.
                                    <em>Source files</em> lists the latest raw Cinedata CSVs with their git history,
                                    to see how long after a play date the admissions keep being corrected.
                                    <em>FTP sync</em> shows the recent downloads from the Cinedata FTP server, compares the
                                    raw folder with the server and can download the last days or one file again.
                                </template>
                            </heading>
                        </div>
                    </div>
                </div>
                <div class="col-10">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Heading from "../../partials/Heading";
import ViewNav from "../../partials/ViewNav";

export default {
    components: {
        Heading,
        ViewNav,
    },
}
</script>
